import moment from 'moment';

export const formatDate = (date: Date, language?: string, includeYear?: boolean) => {
  moment.locale(language);
  const formattedDate = moment(date).format(includeYear ? 'MMMM D, YYYY' : 'MMMM D');
  console.log(formattedDate);
  return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1).toLowerCase();
};
